import {Component, Input, OnInit} from '@angular/core';
import {BranchMeasurement} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";
import {Scale} from "../branch-gauge-setting-measurement/branch-gauge-setting-measurement.component";

@Component({
  selector: 'app-branch-gauge-measurement',
  templateUrl: './branch-gauge-measurement.component.html',
  styleUrls: ['./branch-gauge-measurement.component.css']
})
export class BranchGaugeMeasurementComponent implements OnInit {
  @Input() mVariable: BranchMeasurement | undefined;
  @Input() sVariable: BranchMeasurement | undefined;
  @Input() description: string = "";
  @Input() scale: Scale | undefined;


  mValue: &VariableValue = new VariableValue();
  sValue: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  GetRandomInt(max: number) : number {
    return Math.floor(Math.random() * max);
  }

  ngOnInit(): void {
    if(this.mVariable)
      this.mValue = this.variableDB.AddValueByReference(this.mVariable.variable.id);
    if(this.sVariable)
      this.sValue = this.variableDB.AddValueByReference(this.sVariable.variable.id);
  }

  GetLow(): number {
    return (this.scale) ? this.scale.min : 0;
  }

  GetHigh(): number {
    return (this.scale) ? this.scale.max : 1000;
  }

  GetMeasurement() {
    return this.mValue.val;
  }

  GetSetpoint() {
    return this.sValue.val;
  }

  GetDescription(): string  {
    return  this.description;
  }

  GetUnit(): string {
    return ( this.mVariable)  ? this.mVariable.variable.unit : "";
  }


  GetValueAsString(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  GetMeasurementAsString(): string{
    if(this.mValue.IsInvalid())
      return "NaN";
    return sprintf("%6f", this.GetMeasurement() / 1);
  }

  GetSettingAsString(): string{
    if(this.sValue.IsInvalid())
      return "NaN";
    return sprintf("%6f", this.GetSetpoint() / 1);
  }

  Bottom() : number {
    return  (this.GetSetpoint() - this.RangeLeft());
  }

  RangeLeft() : number
  {
    return ((this.GetSetpoint() - this.GetLow()) / 2 ) * 3;
  }


  RangeRight() : number
  {
    return ((this.GetHigh() - this.GetSetpoint()) / 2 ) * 3;
  }

  Top() : number
  {
    return ((this.GetSetpoint() + this.GetHigh()) / 2 ) * 3;
  }


  GetPointerValue()
  {
    if(this.GetMeasurement()  <= this.GetSetpoint() ) {
      // We are calculating for the left part of the scale
      return (this.GetMeasurement() - this.Bottom()) * (135 / this.RangeLeft());
    } else
    {
      return 135 + (this.GetMeasurement() - this.GetSetpoint()) * (135 / this.RangeRight());
    }
  }

  GetRight() : number{
    var rangeRight = (this.Top() - this.GetSetpoint());
    return 135 + (this.GetMeasurement() - this.GetSetpoint()) * (135 / rangeRight);

  }







  GetLeft() : number{
    var rangeLeft = (this.GetSetpoint() - this.Bottom());
    return (this.GetMeasurement() - this.Bottom()) * (135 / rangeLeft);

  }


  ScaleLeft(): number
  {
    // 25 - 5 = 20
    // 20 = voor 90GrC
    // 20 / 90 = 0,22GrC per BoogGraad
    // BoogGraad * 135 = schaal bereik
    var scaleLeftRange: number = ((this.GetSetpoint() - this.GetLow()) / 90) * 135;
    return scaleLeftRange;
  }


}
